module.exports = __webpack_public_path__ + "static/img/comIcon2.6da07222.png";